import { render, staticRenderFns } from "./SerieSingle.vue?vue&type=template&id=282de95b&"
import script from "./SerieSingle.vue?vue&type=script&lang=js&"
export * from "./SerieSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports